import { MultiInputStreamVisitor } from './multi-input-stream.visitor';
import { ExistsPlainObject } from '../plainObjects/exists.plainObject';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class ExistsVisitor extends MultiInputStreamVisitor {
    protected get _transformation(): ExistsPlainObject {
        return this.transformation as ExistsPlainObject;
    }

    public visitExpression(expression: any): void {
        if (expression) {
            if (expression[0]) {
                this._transformation.customExpression = this._getText(expression[0]);
            }
            this.visit(expression);
        }
    }
}
